import { Controller } from '@hotwired/stimulus'

export default class ActivationSystemController extends Controller {
  static values = { currentStep: Number }
  static targets = [
    'form',
    'stepContent',
    'stepLoader',
    'prevButton',
    'nextButton',
    'resetButton'
  ];

  showLoader (e) {
    this.stepContentTarget.classList.add('hidden')
    this.stepLoaderTarget.classList.remove('hidden')
    this.prevButtonTarget.disabled = true
    this.nextButtonTarget.disabled = true
    this.nextButtonTarget.classList.add('!text-gray-400')

    if (e && e.currentTarget) {
      const form = e.currentTarget.closest('form')
      if (form) {
        form.requestSubmit()
      }
    }
  }

  addFormAction (action) {
    const extraInput = document.createElement('input')
    extraInput.type = 'hidden'
    extraInput.name = action
    extraInput.value = true
    this.formTarget.appendChild(extraInput)
  }

  submitForm (e) {
    if (!this.hasFormTarget) {
      return
    }

    const button = e.currentTarget
    const navAction = button.dataset.navAction

    if (navAction === 'next') {
      if (this.formTarget.checkValidity()) {
        if (button.dataset.skipAssignment) {
          this.addFormAction('skip_assignment')
        }
        this.showLoader()
        this.formTarget.requestSubmit()
      } else {
        this.formTarget.reportValidity()
      }
    } else if (navAction === 'reset') {
      this.formTarget.noValidate = true
      this.addFormAction('reset')
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.noValidate = true
      this.addFormAction('nav_back')
      this.formTarget.requestSubmit()
    }
  }

  async toggleHardware (e) {
    const button = e.currentTarget
    const hardwareType = button.dataset.hardwareType
    const actionType = button.dataset.actionType
    const originalContent = button.innerHTML

    button.disabled = true
    button.innerHTML = '<span class="inline-block animate-spin mr-1">⌛</span>...'

    try {
      const response = await fetch('/activation_system/control_hardware', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ hardware_type: hardwareType, action_type: actionType })
      })

      const result = await response.json()
      if (result.success) {
        button.classList.add('!bg-green-500', '!text-white')
        setTimeout(() => {
          button.classList.remove('!bg-green-500', '!text-white')
        }, 2000)
      } else {
        alert(result.message || 'Action failed')
      }
    } catch (error) {
      console.error('Error toggling hardware:', error)
      alert('Network error')
    } finally {
      button.disabled = false
      button.innerHTML = originalContent
    }
  }
}
